import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function CtaBand() {
  return (
    <section data-testid="cta-band" className="relative bg-gold overflow-hidden grain">
      <div className="absolute -bottom-32 -right-24 w-[26rem] h-[26rem] rounded-full bg-white/25 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-24">
        <Reveal>
          <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
            <div>
              <div className="text-xs font-semibold uppercase tracking-[0.28em] text-obsidian/60 mb-4">
                Free 60-minute consultation
              </div>
              <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-obsidian leading-[1.08] max-w-2xl">
                Let's structure your next move.
              </h2>
            </div>
            <Link
              to="/book"
              data-testid="cta-band-book"
              className="group shrink-0 inline-flex items-center gap-3 rounded-full bg-obsidian text-gold px-9 py-5 text-sm font-semibold tracking-wide transition-all duration-300 hover:shadow-lift hover:-translate-y-0.5"
            >
              Book a meeting
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
